var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380.197,
    height: 380.765,
    viewBox: "0 0 380.197 380.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 380.197,
    height: 380.765,
    fill: "none",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M60.087,258.044,304.659,13.472S319.111-3.137,335.3,10.158L370.77,45.139s12.192,12.984-3.889,28.333L120.413,314.7a174.486,174.486,0,0,1-34.471,26.228c-23.705,13.758-62.306,34.57-79.316,34.841a1.582,1.582,0,0,1-1.591-1.905,373.2,373.2,0,0,1,21.732-66.972,158.291,158.291,0,0,1,33.32-48.844",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M60.087,258.044,304.659,13.472S319.111-3.137,335.3,10.158L370.77,45.139s12.192,12.984-3.889,28.333L120.413,314.7a174.486,174.486,0,0,1-34.471,26.228c-23.705,13.758-62.306,34.57-79.316,34.841a1.582,1.582,0,0,1-1.591-1.905,373.2,373.2,0,0,1,21.732-66.972A158.291,158.291,0,0,1,60.087,258.044Z",
    fill: "none",
    stroke: "#4a4a4a",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 58.857,
    y2: 57.817,
    transform: "translate(275.837 43.528)",
    fill: "none",
    stroke: "#4a4a4a",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 58.857,
    y2: 57.817,
    transform: "translate(253.233 67.236)",
    fill: "none",
    stroke: "#4a4a4a",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M47.591,274.026l27.349.558,2.232,27.349,26.233-2.791-1.675,31.814",
    fill: "none",
    stroke: "#4a4a4a",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ed0294f426bb15781ec0fdb7b08cc66a.svg";
export { ForwardRef as ReactComponent };